// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Reddit+Sans+Condensed:wght@200..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Reddit+Sans+Condensed:wght@200..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Reddit Sans Condensed", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: "Reddit Sans Condensed", sans-serif !important;
}

.font-primary {
  font-family: "Reddit Sans Condensed", sans-serif !important;
}

.table-container {
  height: 80vh;
  overflow-y: auto;
  position: relative;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
}

.custom-table thead {
  position: sticky;
  top: 0;
  background-color: #0093AF; 
  /* z-index: 1;  */
}

.custom-table th,
.custom-table td {
  padding: 4px 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

/* .custom-table tbody tr:hover {
  background-color: #f5f5f5;
} */

.width-100 {
  width: -webkit-fill-available !important;
}

.react-datepicker-wrapper {
  width: -webkit-fill-available !important;
}


.reactDateRangePicker {
  height: 32px !important;
  outline: none !important;
  border-color: #d3d3d3 !important;
  border-radius: 4px !important;
  font-size: 12px !important;
  box-shadow: none !important;
  width: 11rem !important
}

.reactDateRangePicker1 {
  height: 32px !important;
  width: 18vw !important;
  outline: none !important;
  border-color: #d3d3d3 !important;
  border-radius: 4px !important;
  font-size: 12px !important;
  box-shadow: none !important;
}

.reactDateRangePicker2 {
  height: 32px !important;
  width: 14vw !important;
  outline: none !important;
  border-color: #d3d3d3 !important;
  border-radius: 4px !important;
  font-size: 12px !important;
  box-shadow: none !important;
}

.reactDateRangePicker3 {
  height: 32px !important;
  width: 14vw !important;
  outline: none !important;
  border-color: #d3d3d3 !important;
  border-radius: 4px !important;
  font-size: 12px !important;
  box-shadow: none !important;
}





.react-datepicker__header {
  background-color: #0093AF !important;
}

.react-datepicker__current-month {
  color: #fff !important
}

.react-datepicker__day-name {
  color: #fff !important
}

.react-datepicker__day--keyboard-selected {
  background-color: #0093AF !important;
  color: #fff !important;
}

.react-datepicker__close-icon::after {
  background-color: #0093AF !important
}

.scrollBar {
  overflow-X: auto
}

.scrollBar-Y {
  overflow-X: auto
}

.scrollBar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f8f9fa;
}

.scrollBar::-webkit-scrollbar {
  width: 6px;
  height: 16px;
  background-color: #F5F5F5;
}

.scrollBar::-webkit-scrollbar-thumb {
  background-color: #0093AF;
  border-radius: 12px;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.sidebarLink {
  color: #0d6efd !important;
  font-weight: bold !important;
}

.textColorDark {
  color: #07183D
}

.textColorMain {
  color: #0093AF
}

.textColorLight {
  color: #0093AF
}

.textColorMid {
  color: #0093AF
}

.fs16 {
  font-size: 16px !important;
}

.fs20 {
  font-size: 16px !important;
}

.tableCellWidth {
  width: 10rem !important;
  height: 2rem !important;
  /* font-size: 12px !important; */
}

.tableCellWidth input {
  font-size: 14px !important;
}

.tableAutoComplete {
  padding: 0px !important;
}

.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root {
  padding: 0px !important
}

.react-datepicker__header {
  background-color: #0093AF !important;
}

.react-datepicker__current-month {
  color: #fff !important
}

.react-datepicker__day-name {
  color: #fff !important
}

.react-datepicker__day--keyboard-selected {
  background-color: #0093AF !important;
  color: #fff !important;
}

.react-datepicker__close-icon::after {
  background-color: #0093AF !important
}

/* .react-datepicker-ignore-onclickoutside {
  height: 50px !important;
  width: 20vw !important
} */

/* .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
padding: 8.5px 14px !important;
} */

.fs12 {
  font-size: 12px !important;
}

.fs10 {
  font-size: 10px !important;
}


.textfield {
  height: 10px !important;
}

a:-webkit-any-link {
  text-decoration: none !important;
}

.noDecoration {
  text-decoration: none !important;
}

.buttonPadding {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {
  height: 33px !important;
}
/* 
.css-ay7bo9-MuiTypography-root{
  font-family: "Reddit Sans Condensed" !important;
} */

.MuiAutocomplete-inputRoot {
  height: auto !important
}

.MuiAutocomplete-option {
  font-size: 12px;
}

/* .react-datepicker__input-container {
  height:32px !important
} */


@media (max-width: 900px) {
  .hideOnSmallScreens {
    display: none;
  }
}

/* @media (min-width: 900px) and (max-width: 1200px) {
  .fs16 {
    font-size: 8px !important;
  }

  .fs20 {
    font-size: 10px !important;
  }
  
} */

@media (max-width: 600px)  {
  .fs16 {
    font-size: 8px !important;
  }

  .fs20 {
    font-size: 10px !important;
  }

  .fs12 {
    font-size: 6px !important;
  }
  
  .fs10 {
    font-size: 5px !important;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,2DAA2D;EAC3D,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B;AACF;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;AAC7B;;;;;;AAMA;EACE,oCAAoC;AACtC;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;;;GAGG;;AAEH;;GAEG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;AACA;;;GAGG;;AAEH;EACE;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;;GAEG;;;AAGH;EACE;IACE,aAAa;EACf;AACF;;AAEA;;;;;;;;;GASG;;AAEH;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;AAEF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Reddit+Sans+Condensed:wght@200..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Reddit+Sans+Condensed:wght@200..900&display=swap');\nbody {\n  margin: 0;\n  font-family: \"Reddit Sans Condensed\", sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: \"Reddit Sans Condensed\", sans-serif !important;\n}\n\n.font-primary {\n  font-family: \"Reddit Sans Condensed\", sans-serif !important;\n}\n\n.table-container {\n  height: 80vh;\n  overflow-y: auto;\n  position: relative;\n}\n\n.custom-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.custom-table thead {\n  position: sticky;\n  top: 0;\n  background-color: #0093AF; \n  /* z-index: 1;  */\n}\n\n.custom-table th,\n.custom-table td {\n  padding: 4px 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n/* .custom-table tbody tr:hover {\n  background-color: #f5f5f5;\n} */\n\n.width-100 {\n  width: -webkit-fill-available !important;\n}\n\n.react-datepicker-wrapper {\n  width: -webkit-fill-available !important;\n}\n\n\n.reactDateRangePicker {\n  height: 32px !important;\n  outline: none !important;\n  border-color: #d3d3d3 !important;\n  border-radius: 4px !important;\n  font-size: 12px !important;\n  box-shadow: none !important;\n  width: 11rem !important\n}\n\n.reactDateRangePicker1 {\n  height: 32px !important;\n  width: 18vw !important;\n  outline: none !important;\n  border-color: #d3d3d3 !important;\n  border-radius: 4px !important;\n  font-size: 12px !important;\n  box-shadow: none !important;\n}\n\n.reactDateRangePicker2 {\n  height: 32px !important;\n  width: 14vw !important;\n  outline: none !important;\n  border-color: #d3d3d3 !important;\n  border-radius: 4px !important;\n  font-size: 12px !important;\n  box-shadow: none !important;\n}\n\n.reactDateRangePicker3 {\n  height: 32px !important;\n  width: 14vw !important;\n  outline: none !important;\n  border-color: #d3d3d3 !important;\n  border-radius: 4px !important;\n  font-size: 12px !important;\n  box-shadow: none !important;\n}\n\n\n\n\n\n.react-datepicker__header {\n  background-color: #0093AF !important;\n}\n\n.react-datepicker__current-month {\n  color: #fff !important\n}\n\n.react-datepicker__day-name {\n  color: #fff !important\n}\n\n.react-datepicker__day--keyboard-selected {\n  background-color: #0093AF !important;\n  color: #fff !important;\n}\n\n.react-datepicker__close-icon::after {\n  background-color: #0093AF !important\n}\n\n.scrollBar {\n  overflow-X: auto\n}\n\n.scrollBar-Y {\n  overflow-X: auto\n}\n\n.scrollBar::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #f8f9fa;\n}\n\n.scrollBar::-webkit-scrollbar {\n  width: 6px;\n  height: 16px;\n  background-color: #F5F5F5;\n}\n\n.scrollBar::-webkit-scrollbar-thumb {\n  background-color: #0093AF;\n  border-radius: 12px;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.sidebarLink {\n  color: #0d6efd !important;\n  font-weight: bold !important;\n}\n\n.textColorDark {\n  color: #07183D\n}\n\n.textColorMain {\n  color: #0093AF\n}\n\n.textColorLight {\n  color: #0093AF\n}\n\n.textColorMid {\n  color: #0093AF\n}\n\n.fs16 {\n  font-size: 16px !important;\n}\n\n.fs20 {\n  font-size: 16px !important;\n}\n\n.tableCellWidth {\n  width: 10rem !important;\n  height: 2rem !important;\n  /* font-size: 12px !important; */\n}\n\n.tableCellWidth input {\n  font-size: 14px !important;\n}\n\n.tableAutoComplete {\n  padding: 0px !important;\n}\n\n.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root {\n  padding: 0px !important\n}\n\n.react-datepicker__header {\n  background-color: #0093AF !important;\n}\n\n.react-datepicker__current-month {\n  color: #fff !important\n}\n\n.react-datepicker__day-name {\n  color: #fff !important\n}\n\n.react-datepicker__day--keyboard-selected {\n  background-color: #0093AF !important;\n  color: #fff !important;\n}\n\n.react-datepicker__close-icon::after {\n  background-color: #0093AF !important\n}\n\n/* .react-datepicker-ignore-onclickoutside {\n  height: 50px !important;\n  width: 20vw !important\n} */\n\n/* .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\npadding: 8.5px 14px !important;\n} */\n\n.fs12 {\n  font-size: 12px !important;\n}\n\n.fs10 {\n  font-size: 10px !important;\n}\n\n\n.textfield {\n  height: 10px !important;\n}\n\na:-webkit-any-link {\n  text-decoration: none !important;\n}\n\n.noDecoration {\n  text-decoration: none !important;\n}\n\n.buttonPadding {\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n\n.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {\n  height: 33px !important;\n}\n/* \n.css-ay7bo9-MuiTypography-root{\n  font-family: \"Reddit Sans Condensed\" !important;\n} */\n\n.MuiAutocomplete-inputRoot {\n  height: auto !important\n}\n\n.MuiAutocomplete-option {\n  font-size: 12px;\n}\n\n/* .react-datepicker__input-container {\n  height:32px !important\n} */\n\n\n@media (max-width: 900px) {\n  .hideOnSmallScreens {\n    display: none;\n  }\n}\n\n/* @media (min-width: 900px) and (max-width: 1200px) {\n  .fs16 {\n    font-size: 8px !important;\n  }\n\n  .fs20 {\n    font-size: 10px !important;\n  }\n  \n} */\n\n@media (max-width: 600px)  {\n  .fs16 {\n    font-size: 8px !important;\n  }\n\n  .fs20 {\n    font-size: 10px !important;\n  }\n\n  .fs12 {\n    font-size: 6px !important;\n  }\n  \n  .fs10 {\n    font-size: 5px !important;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
